import { batchUpdateDocuments } from 'src/utils/AppUtils';

/** @typedef {
 *   import('../../domain/entities/CareModelCohortAssignment.types').CareModelCohortClientAssignment
 * } CareModelCohortClientAssignment */

/**
 * Persist client cohort assignments.
 *
 * @param {{ assignments: CareModelCohortClientAssignment[] }} params
 * @returns {Promise<void>}
 */
export async function assignClientsToCohorts({ assignments = [] }) {
  if (!assignments.length) {
    return;
  }

  const assignmentsByCohortId = assignments.reduce((acc, { cohortId, clientId }) => {
    if (!acc[cohortId]) {
      acc[cohortId] = [];
    }

    acc[cohortId].push({
      id: clientId,
    });

    return acc;
  }, {});

  await Promise.all(
    Object.entries(assignmentsByCohortId).map(([careModelCohort, clients]) => {
      return batchUpdateDocuments(
        clients,
        { careModelCohort },
        'clients',
      );
    }),
  );
} // assignClientsToCohorts()

/**
 * Clear the cohort assignment of the given clients.
 *
 * @param {{ clientIds: string[] }} params
 * @returns {Promise<void>}
 */
export async function unassignClientsFromCohort({ clientIds = [] }) {
  if (!clientIds.length) {
    return;
  }

  await batchUpdateDocuments(
    clientIds.map((id) => ({ id })),
    { careModelCohort: null },
    'clients',
  );
} // unassignClientsFromCohort()
